export enum HeaderType {
  WHITE,
  BLACK,
  GREY,
}
